import React, { useMemo } from "react";

import blogData from "../../blog/blog.json";
import BlogCard from "../blog/BlogPostCard";

import { Box, Grid, useMediaQuery, useTheme } from "@mui/material";
const BlogColumn = ({ showProjects = false, limit, category }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const itemLimit = limit ?? (isMobile ? 4 : 6);

  const filteredPosts = useMemo(() => {
    return blogData
      .filter((post) => post.isProject === showProjects)
      .filter((post) => !category || post.category === category)
      .sort((a, b) => new Date(b.posted) - new Date(a.posted))
      .slice(0, itemLimit);
  }, [showProjects, itemLimit, category]);

  return (
    <Box sx={{ px: 2, py: 3 }}>
      <Grid container spacing={2} justifyContent="center">
        {filteredPosts.map((post, index) => (
          <Grid item key={post.id} xs={12} sm={6} md={4} lg={3}>
            <BlogCard
              id={post.id}
              title={post.title}
              posted={post.posted}
              category={post.category}
              image={post.image}
              isNew={index === 0}
            />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default BlogColumn;
